import * as React from "react";
import styled from "styled-components/macro";
import NavBar from "../../component/NavBar";
import shapeSrc from "../../assets/images/37.svg";
import { FullPageLoader } from "../../contexts/recommendation-context";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getRecommendationSummary } from "../../utils/enquiry";
import { BackgroundImage } from "./components";
import { ResultSheet } from "./components/ResultSheet";
import { ResultLeft } from "./components/ResultLeft";
import * as mq from "../../styles/mediaQueries";

function ResultPage() {
  const { enquiryId } = useParams();

  const { data, isLoading, isIdle } = useQuery("result", () =>
    getRecommendationSummary(enquiryId),
  );

  if (isLoading || isIdle) return <FullPageLoader />;

  return (
    <div>
      <NavBar />
      <BackgroundImage />
      <div
        css={`
          padding-top: 80px;
          min-height: 100vh;
        `}
      >
        <Background
          css={`
            background: url(${shapeSrc}) no-repeat;
            background-position: 0 5.37em;
          `}
        />

        <Container
          css={`
            display: flex;
            gap: 1em;
            flex-wrap: wrap;
            & > div {
              flex: 1;
            }
            ${mq.sm} {
              flex-direction: column;
            }
          `}
        >
          <ResultLeft data={data} />
          <ResultSheet data={data} />
        </Container>
      </div>
    </div>
  );
}

export default ResultPage;

const Container = styled.main`
  max-width: 1140px;
  margin: auto;
  width: 90%;

  ${mq.sm} {
    font-size: calc(16 * 100vw / 360);
  }
`;

const Background = styled.div`
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 80px;
  z-index: -1;
`;

export const Name = styled.span`
  text-transform: capitalize;
`;

export const FieldErrorMessage = styled.p`
  font-size: 0.87em;
  color: red;
  text-align: center;
`;
